export default __webpack_public_path__ + "scripts/resources/assignments/en/kinetics/iodide_persulfate/spectra.json";